import React from 'react';
import { useTranslation } from '../App';

const Services = () => {
  const t = useTranslation();
  const services = [
    { icon: '🏢', title: t.services.items[0] },
    { icon: '🪑', title: t.services.items[1] },
    { icon: '🏙️', title: t.services.items[2] },
    { icon: '🌿', title: t.services.items[3] },
    { icon: '🔨', title: t.services.items[4] },
    { icon: '💡', title: t.services.items[5] },
    { icon: '📊', title: t.services.items[6] },
    { icon: '📋', title: t.services.items[7] },
    { icon: '🎨', title: t.services.items[8] }
  ];

  return (
    <section className="service" id="service">
      <div className="service-content flex">
        <div>
          <span>{t.services.title}</span>
          <h3>{t.services.heading}</h3>
        </div>
        <div>
          <p>{t.services.description}</p>
        </div>
      </div>
      <div className="flex ser">
        {services.map((service, index) => (
          <div key={index} className={`service-item ${index === 7 ? 'hid' : ''}`}>
            <span className="service-icon">{service.icon}</span>
            <h4>{service.title}</h4>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;